import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminNews = () => {
    const [form, setForm] = useState({
        title: "",
        description: "",
        content: "",
        image: null,
    });

    const [preview, setPreview] = useState(null);
    const [news, setNews] = useState([]);
    const [editId, setEditId] = useState(null);

    // ✅ FETCH (SAFE - NO CRASH)
    const fetchNews = () => {
        fetch(" https://node.ilakshyaerp.in/api/news")
            .then((res) => res.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    setNews(data);
                } else {
                    setNews([]);
                }
            })
            .catch(() => setNews([]));
    };

    useEffect(() => {
        fetchNews();
    }, []);

    // ✅ SUBMIT (LIKE EVENT)
    const handleSubmit = () => {
        if (!form.title || !form.description) {
            alert("Please fill all fields ❌");
            return;
        }

        const formData = new FormData();
        formData.append("title", form.title);
        formData.append("description", form.description);
        formData.append("content", form.content);

        if (form.image) {
            formData.append("image", form.image);
        }

        const url = editId
            ? ` https://node.ilakshyaerp.in/api/news/${editId}`
            : " https://node.ilakshyaerp.in/api/news/add";

        const method = editId ? "PUT" : "POST";

        fetch(url, {
            method,
            body: formData,
        })
            .then(async (res) => {
                const data = await res.json();

                if (!res.ok) {
                    throw new Error(data.message);
                }

                return data;
            })
            .then((data) => {
                alert(data.message || "Success ✅");

                setForm({
                    title: "",
                    description: "",
                    content: "",
                    image: null,
                });

                setPreview(null);
                setEditId(null);
                fetchNews();
            })
            .catch((err) => {
                alert(err.message || "Something went wrong ❌");
            });
    };

    // ✅ EDIT
    const handleEdit = (item) => {
        setForm({
            title: item.title,
            description: item.description,
            content: item.content || "",
            image: null,
        });

        setPreview(` https://node.ilakshyaerp.in/uploads/news/${item.image}`);
        setEditId(item.id);
    };

    // ✅ DELETE
    const handleDelete = (id) => {
        fetch(` https://node.ilakshyaerp.in/api/news/${id}`, {
            method: "DELETE",
        })
            .then((res) => res.json())
            .then(() => fetchNews())
            .catch(() => alert("Delete failed ❌"));
    };

    return (
        <AdminLayout>
            <div className="notice-page">

                {/* FORM */}
                <div className="notice-card">
                    <h2>{editId ? "Edit News" : "Add News"}</h2>

                    <input
                        type="text"
                        placeholder="Enter title"
                        value={form.title}
                        onChange={(e) =>
                            setForm({ ...form, title: e.target.value })
                        }
                    />

                    <input
                        type="text"
                        placeholder="Enter short description"
                        value={form.description}
                        onChange={(e) =>
                            setForm({ ...form, description: e.target.value })
                        }
                    />

                    <input
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        onChange={(e) => {
                            const file = e.target.files[0];

                            if (file.size > 10 * 1024 * 1024) {
                                alert("Image must be less than 10MB ❌");
                                return;
                            }

                            setForm({ ...form, image: file });
                            setPreview(URL.createObjectURL(file));
                        }}
                    />

                    {preview && (
                        <img
                            src={preview}
                            alt="preview"
                            style={{ width: "100%", marginTop: "10px", borderRadius: "8px" }}
                        />
                    )}

                    <button onClick={handleSubmit}>
                        {editId ? "Update News" : "Add News"}
                    </button>
                </div>

                {/* TABLE */}
                <div className="notice-table">
                    <h2>All News</h2>

                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {news.length === 0 ? (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No news found
                                    </td>
                                </tr>
                            ) : (
                                news.map((n) => (
                                    <tr key={n.id}>
                                        <td>
                                            <img
                                                src={` https://node.ilakshyaerp.in/uploads/news/${n.image}`}
                                                width="80"
                                                alt="news"
                                            />
                                        </td>

                                        <td>{n.title}</td>
                                        <td>{n.description}</td>

                                        <td>
                                            <button
                                                className="edit-btn"
                                                onClick={() => handleEdit(n)}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                className="delete-btn"
                                                onClick={() => handleDelete(n.id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </AdminLayout>
    );
};

export default AdminNews;